import { useEffect, useState } from 'react';

function Uzytkownik() {
    const [uzytkownik, setUzytkownik] = useState(null);

    useEffect(() => {
        const userData = localStorage.getItem('uzytkownik');
        if (userData) {
            setUzytkownik(JSON.parse(userData));
        }
    }, []);

    if (!uzytkownik) {
        return <div>Ładowanie danych użytkownika...</div>;
    }

    return (
        <div className="user-profile">
            <h2>Mój profil</h2>
            <p><strong>Imię:</strong> {uzytkownik.imie}</p>
            <p><strong>Nazwisko:</strong> {uzytkownik.nazwisko}</p>
            <p><strong>Email:</strong> {uzytkownik.email}</p>
            <p><strong>Rola:</strong> {uzytkownik.rola}</p>
        </div>
    );
}

export default Uzytkownik;
